<template>
    <div :style="messageColors" class="sc-message--system">
        <slot :message="data">
            <span v-html="data.text" style="word-break: break-all; max-width: 475px" />
            <span v-if="data.meta" :style="{ color: messageColors.color }" class="sc-message--meta">
                {{ data.meta }}</span
            >
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.sc-message--system {
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 12px;
    line-height: 1.2;
    /*white-space: pre-wrap;*/
    -webkit-font-smoothing: subpixel-antialiased;
    font-style: italic;
    opacity: 0.75;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
    word-break: break-word;
}

.sc-message--meta {
    font-size: xx-small;
    margin-bottom: 0;
    margin-top: 5px;
    opacity: 0.5;
    text-align: center;
}
</style>
